import handlebars from "handlebars";
const contentWindow = `!function(a){if("undefined"!=typeof window){var r=!0,P="",u=0,c="",s=null,D="",d=!1,j={resize:1,click:1},l=128,q=!0,f=1,n="bodyOffset",m=n,H=!0,W="",h={},g=32,B=null,p=!1,v=!1,y="[iFrameSizer]",J=y.length,w="",U={max:1,min:1,bodyScroll:1,documentElementScroll:1},b="child",V=!0,X=window.parent,T="*",E=0,i=!1,Y=null,O=16,S=1,K="scroll",M=K,Q=window,G=function(){x("onMessage function not defined")},Z=function(){},$=function(){},_={height:function(){return x("Custom height calculation function not defined"),document.documentElement.offsetHeight},width:function(){return x("Custom width calculation function not defined"),document.body.scrollWidth}},ee={},te=!1;try{var ne=Object.create({},{passive:{get:function(){te=!0}}});window.addEventListener("test",ae,ne),window.removeEventListener("test",ae,ne)}catch(e){}var oe,o,I,ie,N,A,C={bodyOffset:function(){return document.body.offsetHeight+ye("marginTop")+ye("marginBottom")},offset:function(){return C.bodyOffset()},bodyScroll:function(){return document.body.scrollHeight},custom:function(){return _.height()},documentElementOffset:function(){return document.documentElement.offsetHeight},documentElementScroll:function(){return document.documentElement.scrollHeight},max:function(){return Math.max.apply(null,e(C))},min:function(){return Math.min.apply(null,e(C))},grow:function(){return C.max()},lowestElement:function(){return Math.max(C.bodyOffset()||C.documentElementOffset(),we("bottom",Te()))},taggedElement:function(){return be("bottom","data-iframe-height")}},z={bodyScroll:function(){return document.body.scrollWidth},bodyOffset:function(){return document.body.offsetWidth},custom:function(){return _.width()},documentElementScroll:function(){return document.documentElement.scrollWidth},documentElementOffset:function(){return document.documentElement.offsetWidth},scroll:function(){return Math.max(z.bodyScroll(),z.documentElementScroll())},max:function(){return Math.max.apply(null,e(z))},min:function(){return Math.min.apply(null,e(z))},rightMostElement:function(){return we("right",Te())},taggedElement:function(){return be("right","data-iframe-width")}},re=(oe=Ee,N=null,A=0,function(){var e=Date.now(),t=O-(e-(A=A||e));return o=this,I=arguments,t<=0||O<t?(N&&(clearTimeout(N),N=null),A=e,ie=oe.apply(o,I),N||(o=I=null)):N=N||setTimeout(Oe,t),ie});k(window,"message",function(t){var n={init:function(){W=t.data,X=t.source,se(),q=!1,setTimeout(function(){H=!1},l)},reset:function(){H?R("Page reset ignored by init"):(R("Page size reset by host page"),Me("resetPage"))},resize:function(){L("resizeParent","Parent window requested size check")},moveToAnchor:function(){h.findTarget(i())},inPageLink:function(){this.moveToAnchor()},pageInfo:function(){var e=i();R("PageInfoFromParent called from parent: "+e),$(JSON.parse(e)),R(" --")},message:function(){var e=i();R("onMessage called from parent: "+e),G(JSON.parse(e)),R(" --")}};function o(){return t.data.split("]")[1].split(":")[0]}function i(){return t.data.slice(t.data.indexOf(":")+1)}function r(){return t.data.split(":")[2]in{true:1,false:1}}function e(){var e=o();e in n?n[e]():("undefined"==typeof module||!module.exports)&&"iFrameResize"in window||window.jQuery!==a&&"iFrameResize"in window.jQuery.prototype||r()||x("Unexpected message ("+t.data+")")}y===(""+t.data).slice(0,J)&&(!1===q?e():r()?n.init():R('Ignored message of type "'+o()+'". Received before initialization.'))}),k(window,"readystatechange",Ne),Ne()}function ae(){}function k(e,t,n,o){e.addEventListener(t,n,!!te&&(o||{}))}function ue(e){return e.charAt(0).toUpperCase()+e.slice(1)}function ce(e){return y+"["+w+"] "+e}function R(e){p&&"object"==typeof window.console&&console.log(ce(e))}function x(e){"object"==typeof window.console&&console.warn(ce(e))}function se(){function e(e){return"true"===e}function t(e,t){return"function"==typeof e&&(R("Setup custom "+t+"CalcMethod"),_[t]=e,e="custom"),e}{var n;n=W.slice(J).split(":"),w=n[0],u=a===n[1]?u:Number(n[1]),d=a===n[2]?d:e(n[2]),p=a===n[3]?p:e(n[3]),g=a===n[4]?g:Number(n[4]),r=a===n[6]?r:e(n[6]),c=n[7],m=a===n[8]?m:n[8],P=n[9],D=n[10],E=a===n[11]?E:Number(n[11]),h.enable=a!==n[12]&&e(n[12]),b=a===n[13]?b:n[13],M=a===n[14]?M:n[14],v=a===n[15]?v:e(n[15]),R("Initialising iFrame ("+window.location.href+")"),"iFrameResizer"in window&&Object===window.iFrameResizer.constructor&&(n=window.iFrameResizer,R("Reading data from page: "+JSON.stringify(n)),Object.keys(n).forEach(de,n),G="onMessage"in n?n.onMessage:G,Z="onReady"in n?n.onReady:Z,T="targetOrigin"in n?n.targetOrigin:T,m="heightCalculationMethod"in n?n.heightCalculationMethod:m,M="widthCalculationMethod"in n?n.widthCalculationMethod:M,m=t(m,"height"),M=t(M,"width"))}function o(e){F(0,0,e.type,e.screenY+":"+e.screenX)}function i(e,t){R("Add event listener: "+t),k(window.document,e,o)}R("TargetOrigin for parent set to: "+T),le("margin",function(e,t){-1!==t.indexOf("-")&&(x("Negative CSS value ignored for "+e),t="");return t}("margin",c=a===c?u+"px":c)),le("background",P),le("padding",D),(n=document.createElement("div")).style.clear="both",n.style.display="block",n.style.height="0",document.body.appendChild(n),he(),ge(),document.documentElement.style.height="",document.body.style.height="",R('HTML & body height set to "auto"'),R("Enable public methods"),Q.parentIFrame={autoResize:function(e){return!0===e&&!1===r?(r=!0,pe()):!1===e&&!0===r&&(r=!1,fe("remove"),null!==s&&s.disconnect(),clearInterval(B)),F(0,0,"autoResize",JSON.stringify(r)),r},close:function(){F(0,0,"close")},getId:function(){return w},getPageInfo:function(e){"function"==typeof e?($=e,F(0,0,"pageInfo")):($=function(){},F(0,0,"pageInfoStop"))},moveToAnchor:function(e){h.findTarget(e)},reset:function(){Ie("parentIFrame.reset")},scrollTo:function(e,t){F(t,e,"scrollTo")},scrollToOffset:function(e,t){F(t,e,"scrollToOffset")},sendMessage:function(e,t){F(0,0,"message",JSON.stringify(e),t)},setHeightCalculationMethod:function(e){m=e,he()},setWidthCalculationMethod:function(e){M=e,ge()},setTargetOrigin:function(e){R("Set targetOrigin: "+e),T=e},size:function(e,t){L("size","parentIFrame.size("+((e||"")+(t?","+t:""))+")",e,t)}},!0===v&&(i("mouseenter","Mouse Enter"),i("mouseleave","Mouse Leave")),pe(),h=function(){function n(e){var e=e.getBoundingClientRect(),t={x:window.pageXOffset===a?document.documentElement.scrollLeft:window.pageXOffset,y:window.pageYOffset===a?document.documentElement.scrollTop:window.pageYOffset};return{x:parseInt(e.left,10)+parseInt(t.x,10),y:parseInt(e.top,10)+parseInt(t.y,10)}}function o(e){var e=e.split("#")[1]||e,t=decodeURIComponent(e),t=document.getElementById(t)||document.getElementsByName(t)[0];a===t?(R("In page link (#"+e+") not found in iFrame, so sending to parent"),F(0,0,"inPageLink","#"+e)):(t=n(t=t),R("Moving to in page link (#"+e+") at x: "+t.x+" y: "+t.y),F(t.y,t.x,"scrollToOffset"))}function e(){var e=window.location.hash,t=window.location.href;""!==e&&"#"!==e&&o(t)}function t(){Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'),function(e){"#"!==e.getAttribute("href")&&k(e,"click",function(e){e.preventDefault(),o(this.getAttribute("href"))})})}function i(){Array.prototype.forEach&&document.querySelectorAll?(R("Setting up location.hash handlers"),t(),k(window,"hashchange",e),setTimeout(e,l)):x("In page linking not fully supported in this browser! (See README.md for IE8 workaround)")}h.enable?i():R("In page linking not enabled");return{findTarget:o}}(),L("init","Init message from host page"),Z()}function de(e){var t=e.split("Callback");2===t.length&&(this[t="on"+t[0].charAt(0).toUpperCase()+t[0].slice(1)]=this[e],delete this[e],x("Deprecated: '"+e+"' has been renamed '"+t+"'. The old method will be removed in the next major version."))}function le(e,t){a!==t&&""!==t&&"null"!==t&&R("Body "+e+' set to "'+(document.body.style[e]=t)+'"')}function t(n){var e={add:function(e){function t(){L(n.eventName,n.eventType)}ee[e]=t,k(window,e,t,{passive:!0})},remove:function(e){var t=ee[e];delete ee[e],window.removeEventListener(e,t,!1)}};n.eventNames&&Array.prototype.map?(n.eventName=n.eventNames[0],n.eventNames.map(e[n.method])):e[n.method](n.eventName),R(ue(n.method)+" event listener: "+n.eventType)}function fe(e){t({method:e,eventType:"Animation Start",eventNames:["animationstart","webkitAnimationStart"]}),t({method:e,eventType:"Animation Iteration",eventNames:["animationiteration","webkitAnimationIteration"]}),t({method:e,eventType:"Animation End",eventNames:["animationend","webkitAnimationEnd"]}),t({method:e,eventType:"Input",eventName:"input"}),t({method:e,eventType:"Mouse Up",eventName:"mouseup"}),t({method:e,eventType:"Mouse Down",eventName:"mousedown"}),t({method:e,eventType:"Orientation Change",eventName:"orientationchange"}),t({method:e,eventType:"Print",eventNames:["afterprint","beforeprint"]}),t({method:e,eventType:"Ready State Change",eventName:"readystatechange"}),t({method:e,eventType:"Touch Start",eventName:"touchstart"}),t({method:e,eventType:"Touch End",eventName:"touchend"}),t({method:e,eventType:"Touch Cancel",eventName:"touchcancel"}),t({method:e,eventType:"Transition Start",eventNames:["transitionstart","webkitTransitionStart","MSTransitionStart","oTransitionStart","otransitionstart"]}),t({method:e,eventType:"Transition Iteration",eventNames:["transitioniteration","webkitTransitionIteration","MSTransitionIteration","oTransitionIteration","otransitioniteration"]}),t({method:e,eventType:"Transition End",eventNames:["transitionend","webkitTransitionEnd","MSTransitionEnd","oTransitionEnd","otransitionend"]}),"child"===b&&t({method:e,eventType:"IFrame Resized",eventName:"resize"})}function me(e,t,n,o){return t!==e&&(e in n||(x(e+" is not a valid option for "+o+"CalculationMethod."),e=t),R(o+' calculation method set to "'+e+'"')),e}function he(){m=me(m,n,C,"height")}function ge(){M=me(M,K,z,"width")}function pe(){var e;!0===r?(fe("add"),e=g<0,window.MutationObserver||window.WebKitMutationObserver?e?ve():s=function(){function t(e){function t(e){!1===e.complete&&(R("Attach listeners to "+e.src),e.addEventListener("load",i,!1),e.addEventListener("error",r,!1),u.push(e))}"attributes"===e.type&&"src"===e.attributeName?t(e.target):"childList"===e.type&&Array.prototype.forEach.call(e.target.querySelectorAll("img"),t)}function o(e){R("Remove listeners from "+e.src),e.removeEventListener("load",i,!1),e.removeEventListener("error",r,!1),u.splice(u.indexOf(e),1)}function n(e,t,n){o(e.target),L(t,n+": "+e.target.src)}function i(e){n(e,"imageLoad","Image loaded")}function r(e){n(e,"imageLoadFailed","Image load failed")}function a(e){L("mutationObserver","mutationObserver: "+e[0].target+" "+e[0].type),e.forEach(t)}var u=[],c=window.MutationObserver||window.WebKitMutationObserver,s=function(){var e=document.querySelector("body");return s=new c(a),R("Create body MutationObserver"),s.observe(e,{attributes:!0,attributeOldValue:!1,characterData:!0,characterDataOldValue:!1,childList:!0,subtree:!0}),s}();return{disconnect:function(){"disconnect"in s&&(R("Disconnect body MutationObserver"),s.disconnect(),u.forEach(o))}}}():(R("MutationObserver not supported in this browser!"),ve())):R("Auto Resize disabled")}function ve(){0!==g&&(R("setInterval: "+g+"ms"),B=setInterval(function(){L("interval","setInterval: "+g)},Math.abs(g)))}function ye(e,t){return t=t||document.body,t=null===(t=document.defaultView.getComputedStyle(t,null))?0:t[e],parseInt(t,10)}function we(e,t){for(var n,o=t.length,i=0,r=ue(e),a=Date.now(),u=0;u<o;u++)i<(n=t[u].getBoundingClientRect()[e]+ye("margin"+r,t[u]))&&(i=n);return a=Date.now()-a,R("Parsed "+o+" HTML elements"),R("Element position calculated in "+a+"ms"),O/2<(a=a)&&R("Event throttle increased to "+(O=2*a)+"ms"),i}function e(e){return[e.bodyOffset(),e.bodyScroll(),e.documentElementOffset(),e.documentElementScroll()]}function be(e,t){var n=document.querySelectorAll("["+t+"]");return 0===n.length&&(x("No tagged elements ("+t+") found on page"),document.querySelectorAll("body *")),we(e,n)}function Te(){return document.querySelectorAll("body *")}function Ee(e,t,n,o){function i(){e in{init:1,interval:1,size:1}||!(m in U||d&&M in U)?e in{interval:1}||R("No change in size detected"):Ie(t)}function r(e,t){return!(Math.abs(e-t)<=E)}n=a===n?C[m]():n,o=a===o?z[M]():o,r(f,n)||d&&r(S,o)||"init"===e?(Se(),F(f=n,S=o,e)):i()}function Oe(){A=Date.now(),N=null,ie=oe.apply(o,I),N||(o=I=null)}function L(e,t,n,o){i&&e in j?R("Trigger event cancelled: "+e):(e in{reset:1,resetPage:1,init:1}||R("Trigger event: "+t),("init"===e?Ee:re)(e,t,n,o))}function Se(){i||(i=!0,R("Trigger event lock on")),clearTimeout(Y),Y=setTimeout(function(){i=!1,R("Trigger event lock off"),R("--")},l)}function Me(e){f=C[m](),S=z[M](),F(f,S,e)}function Ie(e){var t=m;m=n,R("Reset trigger event: "+e),Se(),Me("reset"),m=t}function F(e,t,n,o,i){!0===V&&(a===i?i=T:R("Message targetOrigin: "+i),R("Sending message to host page ("+(e=w+":"+(e+":"+t)+":"+n+(a===o?"":":"+o))+")"),X.postMessage(y+e,i))}function Ne(){"loading"!==document.readyState&&window.parent.postMessage("[iFrameResizerChild]Ready","*")}}();`;
const rawBNPLContract = `
<html>
  <head>
    {{{resizerScript}}}
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet">
    <style>

      body {
        font-family: Verdana, sans-serif;
      }

      @media print {
        @page {
          size: A4 portrait;
        }

        * {
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }

        ul, ol {
          page-break-before: avoid;
        }

        p, ul, ol {
          page-break-inside: avoid;
        }

        h2, h3, h4, th {
          page-break-after: avoid;
        }

        .page {
          break-before: page;
        }
      }

      .center {
        text-align: center;
      }

      .bold {
        font-weight: bold;
      }

      .italic {
        font-style: italic;
      }

      .colour-black {
        color: #000;
      }

      .underline-none {
        text-decoration: none;
      }

      .bg-grey {
        background-color: #f0f0f0; /* TODO: use theme colour */
      }

      .grid-auto-fr {
        grid-template-columns: auto 1fr;
      }

      .grid-fr-fr {
        grid-template-columns: 1fr 1fr;
      }

      .grid {
        display: grid;
        justify-content: space-between;
      }

      .col-gap-8 {
        column-gap: 2rem;
      }

      .grid-cols-2 {
        grid-template-columns: repeat(2, minmax(10px, 1fr));
      }

      .margin-left-2rem {
        margin-left: 2rem;
      }

      .margin-left-1_5rem {
        margin-left: 1.5rem;
      }

      .padding-0_5rem {
        padding: 0.5rem;
      }

      .overflow-x-auto {
        overflow-x: auto;
      }

      .min-w-160 {
        min-width: 40rem;
      }

      .min-w-100 {
        min-width: 25rem;
      }

      .break-word {
        word-break: break-word;
      }

      .border {
        border: solid 1px black;
      }

      .border-spacing-2 {
        border-spacing: 2px;
      }

      .p-2 {
        padding: 0.5rem;
      }

      .pb-20 {
        padding-bottom: 5rem;
      }

      .pr-0 {
        padding-right: 0rem;
      }

      .mb-1 {
        margin-bottom: 0.25rem;
      }

      @media screen and (max-width: 640px) {
        .md\\:col-gap-4 {
          column-gap: 1rem;
        }

        .md\\:grid-cols-1 {
          grid-template-columns: auto;
        }

        .md\\:pb-4 {
          padding-bottom: 1rem;
        }

        .md\\:pr-4 {
          padding-right: 1rem;
        }
      }

      table {
        border-collapse: separate;
        table-layout: fixed;
      }

      td, th {
        padding-top: 1rem;
        padding-right: 0.5rem;
        padding-left: 0.5rem;
        outline: 1px solid #000;
        text-align: left;
        vertical-align: top;
        height: 2rem;
      }

      td {
        padding-bottom: 1rem;
      }

      table {
        width: 100%;
      }

      .column-2 {
        column-count: 2;
      }

      .column-span-all {
        column-span: all;
      }

      h3 {
        font-style: none;
      }

      /* Contract counter styles */

      .counter {
        counter-reset: section;
      }

      .counter h3 {
        counter-increment: section;
        counter-reset: subsection;
      }

      .counter h3::before {
        content: counter(section) ". ";
      }

      .counter p {
        counter-increment: subsection;
        position: relative;
        padding-left: 3rem;
      }

      .counter p::before {
        content: counter(section) "." counter(subsection) " ";
        position: absolute;
        left: 0rem;
        margin-right: 100%;
      }

      .counter > .counter-skip {
        counter-increment: none;
      }

      .counter > .counter-skip::before {
        content: '';
      }

      /* Ordered List Styles */
      ol li {
        margin-left: 0.5rem;
        display: list-item;
        padding-left: 2rem;
      }

      /* Extending based on: https://www.w3.org/TR/css-counter-styles-3/#predefined-counters */
      @counter-style metrics-alpha {
        system: extends lower-alpha;
        prefix: "(";
        suffix: ")";
      }

      @counter-style metrics-roman {
        system: extends lower-roman;
        prefix: "(";
        suffix: ")";
      }

      ol.lower-alpha {
        list-style-type: metrics-alpha;
      }

      ol.lower-roman {
        list-style-type: metrics-roman;
      }

      ul.none {
        list-style-type: none;
      }

      .list-padding-below > li {
        padding-bottom: 1rem;
      }

      ul.star {
        list-style-type: "*  ";
      }
    </style>
    <title>Navalo Financial Services Group Pty Ltd
    BNPL Contract</title>
  </head>
  <body>
    <h1 class="center">Navalo Financial Services Group Pty Ltd </br>
    BNPL Contract</h1>
    <div class="center">ACN 605 753 535
    Australian Credit Licence Number 533485</div>
    <section>
    <h2>Credit Contract</h2>
    <div class="bg-grey grid grid-auto-fr md:col-gap-4 col-gap-8 padding-0_5rem">
      <div class="bold">Lender:</div>
      <div>Navalo Financial Services Group Pty Ltd ACN 605 753 535, Australian Credit Licence 533485 of Level 16, 1 Martin Place, Sydney, NSW 2000 as agent for Devizo Finance Pty Ltd.<span class="bold break-word">(us/we/our)</span></div>
      <div class="bold">Borrower:</div>
      <div>{{customer.firstName}} {{customer.middleName}} {{customer.lastName}}<span class="bold break-word">(you/your)</span> of {{address}}<!-- build this out --></div>
    </div>
    </section>
    <section>
      <h2>Financial Table</h2>
      <p>The following information is prepared as at {{currentDate}} (<span class="italic">disclosure date</span>). This information may change</p>
      <div class="overflow-x-auto">
        <table class="min-w-160">
          <tbody>
            <tr>
              <!-- TODO: determine what is meant to go here -->
              <td class="bold">Credit Limit</td>
              <td>{{plan.totalCreditAmount}}</td>
            </tr>
            <tr>
              <td>Repayment Amount</td>
              <td>
              The repayment amount is determined by reference to the amount of credit borrowed under this BNPL Contract including any fees (up to the capped amount) divided by the number of scheduled repayments for any given purchase. Where there are multiple purchases, the amount calculated for each purchase is added together to get the total repayment amount.  
              </td>
            </tr>
            <tr>
              <td>Frequency of repayments</td>
              <td>{{plan.repaymentFrequency}}</td>
            </tr>

            <tr>
              <td class="bold">Credit fees and charges payable on or before we fund your BNPL Contract</td>
              <td>None</td>
            </tr>
            <tr>
              <td class="bold">Credit fees and charges that are payable after the date we fund your BNPL Contract</td>
              <td></td>
            </tr>
            <tr>
              <td>Establishment Fee payable in instalments in relation to your first BNPL Plan</td>
              <td>
                This amount depends on the repayment schedule of the BNPL Plan as follows:
                <ul>
                  <li>2 Months - $0</li>
                  <li>3 Months - $5.00</li>
                  <li>6 Months - $39.00</li>
                  <li>12-18 Months - $69.90</li>
                  <li>24-36 Months - $74.90</li>
                  <li>48-60 Months - $89.95</li>
                </ul>
                <p>The relevant amount is debited to your Loan Account at commencement of the Plan and amortised over the life of the Plan.</p> 
              </td>
            </tr>
              <tr>
              <td>Repeat Purchase Fee payable in relation to any subsequent BNPL Plan</td>
              <td>
                This amount depends on the repayment schedule of the BNPL Plan as follows:
                <ul>
                  <li>2 Months - $0</li>
                  <li>3 Months - $5.00</li>
                  <li>6 Months - $19.95</li>
                </ul>
              <!--- <p>{{totalFee}} payable in {{plan.terms}} of {{periodicFee}} per {{plan.repaymentFrequency}}<p> -->
                <p>The relevant amount is debited to your Loan Account at commencement of the Plan and amortised over the life of the Plan.</p>
              </td>
            </tr>
            <tr>
              <td>Account Keeping Fee payable on each repayment date. This fee is not charged when your BNPL Contract has a zero-credit balance.</td>
              <td>{{#if isMonthly}} {{plan.accountKeepingFee}} per month {{/if}} {{#if isFortnightly}} {{plan.accountKeepingFee}} per fortnight {{/if}} debited to the Loan Account on each Repayment Date</td>
            </tr>
            <tr>
              <td>Payment processing fee in relation to your BNPL Contract</td>
              <td>{{plan.paymentProcessingFee}} per repayment</td>
            </tr>
            <tr>
              <td class="bold">Credit fees and charges that may be payable after the date we fund your BNPL Contract</td>
              <td></td>
            </tr>
            <tr>
              <td>Late Payment Fee payable when a scheduled payment is missed</td>
              <td>If you do not have any outstanding payments: $5 payable if payment is 1 day late $7.95 payable if payment is 7 days late.
                <br><br>
                If you do have other outstanding payments: $12.95 if a payment is 1 day late.
                <br><br>
                We will not charge you more than the lower of 10% of your Credit Limit or $120 for each Fee Period of your BNPL Plan.
              </td>
            </tr>
      

            <tr>
              <td colspan="2">Acting reasonably, we may change any of the financial information described above without your consent, including the fees and charges, the amount of repayments and the dates for making repayments. We may introduce new fees and charges without your consent. We will inform you of any changes either in writing or by advertisement in a newspaper circulating throughout your jurisdiction. In making any changes, we will act reasonably.</td>
            </tr> 
          </tbody>
        </table>
      </div>
      <h2>OTHER PROVISIONS</h2>
      <table>
        <tbody>
          <tr>
            <td><span class="bold">BNPL Contract purpose: </span>Allowing you to spread the cost of your purchases from participating Payright Merchants through repayments under your BNPL Contract rather than paying the full purchase price up front.  </td>
          </tr>
        </tbody>
      </table>
    </section>
    <p class="center">Please read the terms of this contract carefully.</p>
    <p class="center">If you have any problems, you should always contact us directly at <a href="mailto:care@payright.com.au">care@payright.com.au</a> or phone <a href="tel:+611300338396" class="bold underline-none colour-black">1300 338 496</a>. We will endeavour to resolve your query, but if you still have concerns, you should contact our
    Internal Dispute Resolution (<span class="bold">IDR</span>) team to make a formal complaint to <a href="mailto:complaints@payright.com.au">complaints@payright.com.au</a><span class="bold"> or phone <a href="tel:+611300338396" class="underline-none colour-black">1300 338 496</a>.</span> There are no fees or charges for contacting our IDR team.</p>
    <p class="bold">IF YOU CANNOT MAKE A PAYMENT, CONTACT US IMMEDIATELY TO DISCUSS YOUR
    SITUATION BY PHONE ON <a href="tel:+611300338396" class="underline-none colour-black">1300 338 496</a> OR EMAIL <a href="mailto:care@payright.com.au">CARE@PAYRIGHT.COM.AU</a>.</p>
    <br><div class="page"></div>
    <section class="column-1 counter">
      <h2 class="center column-span-all">BNPL Contract - Terms and Conditions</h2>
      <h3>Offer of Loan</h3>
      <p>
        We offer to make the Credit Limit available to you on the terms set out in this BNPL Contract. This BNPL Contract should be read together with:
      </p>
      <ol class="lower-alpha">
        <li>the Payright Account Terms and
        Conditions;</li>
        <li>the Application;</li>
        <li>the Financial Table; and</li>
        <li>the Repayments Schedules. </li>
      </ol>
      <p class="counter-skip">
        (collectively, ‘your Agreement’).
      </p>
      <p>
        Your acceptance of this BNPL Contract will constitute your agreement to the terms of this BNPL Contract and amounts to your acceptance of the offer we have made to you.
      </p>
      <p>If you have an existing BNPL Contract with us, this BNPL Contract replaces your existing BNPL Contract. Any active Plans under your previous BNPL Contract will be transitioned to this BNPL Contract, will operate to reduce your Credit Limit, and will otherwise operate without change to your plan terms, repayment dates, or repayment amounts.</p>
      <p>Payright has elected to comply with the modified responsible lending obligations under Pt 3-2BA of the Credit Act in relation to this BNPL Contract.</p>
      <p>
        <span class="bold">The Plan Date must take place within 120 days of the date you accept this BNPL Contract.</span> If we do not disburse funds within that time (or any extension granted by us, acting reasonably), we may notify you of our decision to terminate this BNPL Contract.
      </p>
      <p>
        If any of the following circumstances arise prior to the disbursement of any initial funds, we will not disburse any funds:
      </p>
      <ol class="lower-alpha">
        <li>the Participating Merchant notifies us that your purchase has been cancelled;</li>
        <li>you fail to pay any fees specified in the Financial Table to be payable prior to disbursement;</li>
        <li>information has come to our attention or an event has occurred which in our reasonable opinion would have a material impact (as that term is defined in clause 11.1);</li>
        <li>we have formed a reasonable suspicion that the Application is not bona fide.</li>
      </ol>
      <p>You acknowledge and agree that:</p>
      <ol class="lower-alpha">
        <li>You have carefully read this BNPL Contract and your Agreement;</li>
        <li>all information provided to us as part of your Application and which has been relied upon for the purpose of providing this BNPL Contract is true, accurate and complete;</li>
        <li>you have not relied on any statements or representations made by third parties in relation to your decision to obtain a BNPL Plan;</li>
        <li>that the BNPL Contract is only to be used for the purpose that your provided as part of any Application.</li>
      </ol>
      <p>
          You warrant that at the time of this BNPL Contract and when making any Application that you: 
      </p>
      <ol class="lower-alpha">
        <li>Are an Australian citizen or permanent resident;</li>
        <li>Are over the age of 18;</li>
        <li>Derive an income or other regular source of revenue; and</li>
        <li>Provided true, accurate and complete information in your Application.</li>
      </ol>
      <h3>Advances of funds</h3>
      <p>
        After you sign this BNPL Contract and the Participating Merchant nominated in your Application in respect of your purchase has confirmed to us that your purchase is complete, we will advance a maximum of the full amount of the Credit Limit to you by paying it to the Participating Merchant. Once the Credit Limit is used in connection with a purchase, your BNPL Contract will commence. 
      </p>
      <p>
        Where you make a repayment in accordance with clause 3, an equivalent amount of your Credit Limit will become available again for your use upon making an Application.
      </p>
      <p>
        You may make an Application to us at any time to use part of your Available Credit Limit, such Applications to be in accordance at all times with this BNPL Contract, the Payright Account Terms and Conditions and any other directions we provide regarding how to make a Application. An Advance in connection with an approved Application will be paid to the Participating Merchant to pay for nominated purchase. 
      </p>
      <p>For each Advance we make, we will issue you with a new Repayment Schedule providing you with information specific to that Advance about: </p>
      <ol class="lower-alpha">
        <li>how and when to repay that Advance;</li>
        <li>any Fees and Charges applicable to the Advance; and </li>
        <li>any special or promotional offers applicable to that Advance.</li>
      </ol>
      <p>
        Other than your initial Advance of credit when your BNPL Contract commences, no Advance will be made to you by us where:
      </p>
      <ol class="lower-alpha">
        <li>you are currently in Default;</li>
        <li>this would result in the Unpaid Balance exceeding the Credit Limit;</li>
        <li>we have reason to believe doing so will place you in financial hardship;</li>
        <li>we have reason to believe you are in breach of your obligations under this Agreement; or  </li>
        <!-- TODO: Do i need to include the wrapper here? -->
        <li>you do not comply with any deposit requirement.</li>
      </ol>
      <p>
        If your Application is conditionally approved in relation to an intended purchase, the amount of the Available Credit Limit and the conditions that must be satisfied before you can use this amount for your intended purchase will be notified to you.
      </p>
      <p>
       We may require you to pay part of the cost of a purchase from a Participating Merchant. Payright as a deposit amount. Where this is the case, we will: 
      </p>
        <ol class="lower-alpha">
          <li>Reduce the amount of any requested Advance to equal the cost of the goods or services, less the deposit; </li>
          <li>advise the Participating Merchant of any deposit amount required;</li>
          <li>Require you to pay any required deposit either directly to the Participating Merchant or to Payright as directed.</li>
          <li>not permit you to use your Account to pay the balance until the deposit has been paid and the Participating Merchant confirms to us they have provided or arranged delivery of the purchase to you.</li>
        </ol>
      <h3>Repayments</h3>
      <p>You must repay the Unpaid Balance to us in accordance with this Agreement.</p>
      <p>You must pay all Repayment Amounts due to us in accordance with this BNPL Contract or any Advance as notified by us to you when making an Advance.</p>
      <p>
       Repayments will be credited to your Loan Account when they are actually received by us and (subject to clause 3.7) will be applied to your Unpaid Balance as determined by us (acting reasonably). All payments that must be made by you under this BNPL Contract must be made in full, without any deduction, set-off or counterclaim, provided that if you claim that we owe you any amount for any reason, then nothing in this clause will prevent you from bringing a claim for this amount against us.
      </p>
      <p>
       Repayments are to be made by recurring payment on your credit or debit card or by direct debit from your nominated bank account unless we agree to permit payment by some other method (acting reasonably). You must sign any forms reasonably required by us and do anything reasonably required by us to effect repayments.    </p>
      <p>
        You request and authorise us to debit the periodic Repayment Amount or any Fees and Charges from your credit or debit card or your nominated bank account due by you under this loan on each payment due date. The amount of each payment may include any applicable direct debit fees, taxes or charges relating to the payment method. Where you are late in making a payment, we may aggregate amounts and debit this as one amount to your nominated debit card, credit card or bank account.
      </p>
      <p>
        You authorise us to debit the periodic Repayment Amount or any Fees and Charges in accordance with the direct debit authorisation as they become due. You must ensure that the account always has sufficient credit or funds to meet your repayment obligations. If you fail to have sufficient funds in your account, payment may be dishonoured, and a fee may apply. You must not unreasonably cancel the direct debit authority, represent to your bank that the direct debit authority you have given us is unauthorised, or close your account or card without making alternate arrangements and without our prior consent.
      </p>
      <p>
       We may use any payment we receive from you to satisfy any amount that you are due to pay in respect of the BNPL Contract in any manner we choose (acting reasonably). For example, we may choose to apply a payment in satisfaction of outstanding enforcement fees or late payment fees in priority to any outstanding scheduled minimum repayments. In most cases, we will apply payments in the following order:
      </p>
      <ol class="lower-alpha">
        <li>enforcement Fees;</li>
        <li>late Payment Fees;</li>
        <li>other fees and charges; and</li>
        <li>outstanding balances in relation to
        purchases.</li>
      </ol>
      <p>If your direct debit or recurring payment method used for repayment is dishonoured:</p>
      <ol class="lower-alpha">
        <li>that payment will not be considered as having been made; and</li>
        <li>
          any applicable Fees and Charges specified under the BNPL Contract will become due and owing and will be debited to your Loan Account from the date the direct debit was attempted.
        </li>
      </ol>
      <p>
      If a direct debit is unsuccessful, we may make further attempts to debit the amount of the missed Repayment Amount from your account. Where you have multiple unsuccessful payments, we will limit the number of successful loan repayments to no more than three (3) on any one day.  Your financial institution may charge you fees if this occurs. If we are processing unpaid Late Fees, there is no limit on how many we will process in any one day
      </p>
      <p>
       If any repayment is due to be made on a day which is not a business day, the repayment must be made on the next business day. If any payment is due on a day which is the 29th, 30th or 31st of a month with no such date, the payment must be made on the first day of the following month.
      </p>
      <p>
        If you have more than one loan with us, and any of your loans with us are in arrears or default, we may, at our discretion, and subject to appropriate hardship procedures being followed by us, suspend or terminate this loan or other loans after providing you reasonable notice to rectify the arrears or default, where permitted by law.
      </p>
      <p>
        If you do not pay a Repayment Amount by the due date, we may elect not to provide any further Advances to you under this BNPL Contract until your loan is brought up to date and you satisfy any other requirements we reasonably impose.  
      </p>
      <h3>Credit Limit Increase</h3>
      <p>If you wish to increase the Credit Limit under your BNPL Contract, you can make an Application to us.</p>
      <p>Any Application for an increase in your Credit Limit is subject to meeting Payright’s eligibility criteria and passing any responsible lending and credit decisioning criteria we apply.</p>
      <p>If we approve your Credit Limit increase Application, we will issue you with a new BNPL Contract with a new credit limit. If you sign that new BNPL Contract, this BNPL Contract will terminate and you will enter into a new BNPL Contract for the applicable increased Credit Limit.</p>
      <p>Any Unpaid Balance on your BNPL Contract will be transferred to your new BNPL Contract at no charge and the Repayment Schedule/s that applied to the Unpaid Balance will continue to apply unchanged.</p>
      
      <h3>Early repayment and final repayment adjustments</h3>
      <p>
        You can repay the whole or any part of the Unpaid Balance at any time. We may charge a payment processing fee in respect of any additional repayments you make. This payment processing fee is included in the calculation of the maximum fee amount in clause 8.4. If you want to pay the Unpaid Balance in whole and terminate this BNPL Contract, you must tell us the date you want to do this, and we will tell you the amount you owe on the day.
      </p>
      <p>
      If you repay only part of your Unpaid Balance early, you will still be required to make the minimum repayments required in accordance with the direct debit arrangements regardless of the additional repayments.
      </p>
      <p>
        We will not pay interest on excess funds received by us (i.e., if you repay too much).
      </p>
      <p>
      We may adjust your final repayment amount to the amount required (the Adjusted Final Repayment Amount) to repay your Unpaid Balance and accrued fees on the final repayment date, for example if you have made an early repayment, you have made late payments, or to adjust for the number of days in the repayment period or rounding. Your Adjusted Final Repayment Amount may be higher or lower than your scheduled repayment amount, but it will not be more than $2 higher than your scheduled repayment amount. 
      </p>
      <h3>Identification information and credit report</h3>
      <!-- TODO: do we want the link to be black? -->
      <p>
       We will collect, store, use and share your personal information (including sensitive information) such as your contact and identification details or geographical information. For more information, go to [<a target="_blank" class="break-word" href="https://www.payright.com.au/privacy-policy/">https://www.payright.com.au/privacy-policy/</a>].  
      </p>
      <p>
        We may ask a credit reporting body to assist in verifying your identity by providing us with an assessment of whether the information we hold about you matches their records. The credit reporting body may use this information and the information held by the body of other individuals for the purpose of preparing and providing this assessment to us.
      </p>
      <p>
      We may further collect, hold, use and disclose your bank statement and credit information such as your credit history, eligibility and credit contract information to request a credit reporting body to pre-screen your credit score in order to proceed with an application for credit and comply with our obligations to report a credit reporting body and/or assist us in assessing any financial application you make and will be done so in accordance with our Privacy Policy.
      </p>
      <p>
      The credit reporting body we may disclose your personal information and credit information to is Equifax. You can get a free copy of your credit report with Equifax by contacting them on <a href="tel:+61138332" class="colour-black">138 332</a>, <a target="_blank" class="break-word" href="https://equifax.com.au/personal/products/my-credit-file">https://equifax.com.au/personal/products/my-credit-file</a> or GPO BOX 1969 North Sydney NSW 2060. To obtain Equifax’s policies about their management of credit-related personal information, please visit their website.  
      </p>
      <p>
       Our sharing of information about your missed repayments and defaults with the credit reporting body may impact your creditworthiness and your ability to obtain credit in the future. We will only do this if you miss a payment in the Loan Contract, where you have defaulted on the Loan Contract or where you make a serious credit infringement, which is outlined below (Refer to clause 11 (Default)). We may also provide updates to the credit reporting body on any payments we receive after we disclose missed payments and defaults.
      </p>
      <h3>Interest charges</h3>
      <p>There are no interest charges payable under this BNPL Contract.</p>
      <h3>Fees and charges</h3>
      <p>
      You must pay any fees and charges which become payable under the BNPL Contract as listed in the Financial Table to this BNPL Contract.
      </p>
      <!-- are these to use the same incremental numbering as the surrounding items? -->
      <p>
        If the fee or charge is payable to us, you authorise us to debit your credit card or your nominated bank account with the amount due on the relevant payment date for that fee or charge.  If the payment of a fee or charge is unsuccessful, we will debit this amount to your Loan Account. 
      </p>
      <p>You agree to pay the fees and charges specified in the Financial Table in instalments over the repayment term.</p>
      <p>
       Payright will not charge you more than a total of $200 in fees (other than default fees) listed in the Financial Table in the Initial Fee Period or $125 in each Subsequent Fee Period.     
      </p>
      <!-- both parenthesis closed at end -->
      <p>
      Any fees and charges or other amounts that have accrued and remain outstanding on the final repayment date must be paid along with the final repayment, subject to adjustments if clause 5.4 applies.
      </p>
      <h3>Late Fees</h3>
      <p>
      If you fail to pay any amount by the due date (including because a direct debit is unsuccessful), we will issue you with a Late Payment Notice and may charge you a Late Payment Fee (if specified in the Late Payment Notice) or part thereof.
      </p>
      <p>
        We will provide you with notice in accordance with clause 9.1 before any late fees are charged so that you can contact us to make any required repayments.  
      </p>
      <p>
      Where you contact us immediately or make the required repayment within the notice period set out in the Late Payment Notice, no late fees will be charged
      </p>
      <p>
      The total amount of Late Payment Fees will be capped at any amount set out in the Credit Act.
      </p>
      <h3>Variations to your Loan Contract</h3>
      <p>
        There may be times when we need to make changes to your BNPL Contract. When we make changes, we will always act fairly and honestly towards you.
      </p>
      <p>
        If we are required to give you notice of a change, it will be provided in writing. You will receive notice personally. The notice we will provide is set out in the table below.  
      </p>
      <p>
       Where permitted by law, we may give you a notice period that is shorter than set out in the table below, or no notice, of an unfavourable change if we reasonably consider urgent action is necessary to avoid or reduce a material increase in our credit, security, regulatory or reputational risk.
      </p>
      <p>
      You may choose to terminate this BNPL Contract early due to a change made by us under this clause. If you do so, then you must give us reasonable notice and pay the Unpaid Balance.
      </p>
      <p>
        The changes we may make, and how we will notify you of these changes, is set out in the table below:
      </p>
      <div class="overflow-x-auto">
        <table class="column-span-all min-w-160">
          <tbody>
            <tr>
              <th colspan="2">Type of change</th>
              <th>Notice of change</th>
            </tr>
            <tr>
              <td rowspan="2" class="bold">Repayments</td>
              <td>Changing the amount of a repayment</td>
              <td>30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement</td>
            </tr>
            <tr>
              <td>Changing the method of calculating repayments, or the number or frequency of repayments, or the time for making repayments</td>
              <td>30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement</td>
            </tr>
            <tr>
              <td rowspan="3" class="bold">Fees and Charges</td>
              <td>Changing the amount of any Fees and Charges</td>
              <td>30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement</td>
            </tr>
            <tr>
              <td>Adding any new Fees and Charges</td>
              <td>30 days</td>
            </tr>
            <tr>
              <td>Changing the method of calculating, or the time or frequency of payment, of any Fees and Charges</td>
              <td>30 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement</td>
            </tr>
            <!-- TODO: are these meant to have "?" as list markers? -->
            <tr>
              <td rowspan="2" class="bold">Government fees and charges</td>
              <td>Adding a new fee or charge set by the government</td>
              <td>
                No later than the day on which the change takes effect, unless:
                <ul>
                  <li>we reasonably consider that the change is not adverse to you, in which case we will notify you in writing before, or with, your next statement; or</li>
                  <li>it is publicised by the government, in which case we do not need to notify you.</li>
                </ul>
            </td>
            <tr>
              <td>Changing an existing fee or charge set by the government</td>
              <td>
                No later than the day on which the change takes effect, unless:
                <ul>
                  <li>we reasonably consider that the change is not adverse to you, in which case we will notify you in writing before, or with, your next statement; or</li>
                  <li>it is publicised by the government, in which case we do not need to notify you.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td class="bold"> Other changes</td>
              <td>
                In addition to our ability to make the changes outlined above, we can change any term of your BNPL Contract:
                <ul>
                  <li>if we reasonably consider that the change is not adverse to you</li>
                  <li>to comply with any law, standard, regulator guidance, decision of a court or AFCA</li>
                  <li>if we consider it reasonably necessary to manage our regulatory, credit or security risk</li>
                  <li>if we consider it reasonably necessary to reflect current industry or market products or conditions</li>
                  <li>if the change is administrative or minor, or to correct a mistake, inconsistency, ambiguity or omission</li>
                  <li>if the change reflects changes to our business or technological systems</li>
                  <li>
                    if a product or service has been discontinued, to provide you with a product or service which is substantially similar to the discontinued product or service
                  </li>
                  <li>to protect us or any other person from the risk of fraud or illegal activity</li>
                  <li>if the change is otherwise reasonably necessary to protect our legitimate interests</li>
                </ul>
              </td>
              <td>20 days, or where we reasonably consider that the change is not adverse to you, we will notify you in writing before, or with, your next statement</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3>Default</h3>
      <p>If any one or more of the following occur, we may decide that default has occurred:</p>
      <ol class="lower-alpha">
        <li>For any reason, you do not pay any amount when it is due, including Repayment Amounts and Late Fees;</li>
        <li>Do any of the following where it has a material impact on us:
          <ol class="lower-roman">
            <li>there is a breach by you of any term or condition of this BNPL Contract or the Agreement.</li>
            <li>any representation made by you in relation to your Application for this BNPL Contract was untrue or misleading.</li>
            <li>you breach any material undertaking given at any time to us.</li>
            <li>you do not comply with the law.</li>
            <li>you have more than one loan with us, and any of your loans with us are in arrears or default.</li>
          </ol>
        </li>
        <li>You become bankrupt or are jailed.</li>
      </ol>
      <p class="counter-skip">
        In this clause 11.1, “material impact” means where we reasonably consider that the event, by its nature, is material or the event has had, or is likely to have, a material impact on:
      </p>
      <ol class="lower-alpha">
        <li value="4">your ability to meet your obligations under this BNPL Contract, including but not limited to your obligation to make repayments;</li>
        <li>our credit or security risks (or our ability to assess these); or</li>
        <li>our legal risks or reputation.</li>
      </ol>
      <p>
        At any time after default occurs, we can take any of the following actions after giving you a Default Notice:
      </p>
      <ol class="lower-alpha">
        <li>Demand and require payment of any money due under this Loan Contract within 30 days following the expiry of the period outlined in the Default Notice;</li>
        <li>Terminate this BNPL Contract;</li>
        <li>close, cancel or suspend your Payright Account;</li>
        <li>take further action to enforce our rights and recover the amounts due including (but not limited to) default listing with a credit reporting body, referring you to a third party debt collection agency or selling your debt to a third party.</li>
      </ol>
      <p class="counter-skip">
        We can take action even if we do not do so promptly after the default occurs.
      </p>
      <p>
        We will issue you with a Default Notice before we exercise any of our rights under clause 11.2. The Default Notice will advise you of the default and notify you of how to remedy it and by when it must be remedied.  For the avoidance of doubt, we will provide you with at least 30 days’ notice from the date of the Default Notice to remedy any default.
      </p>
      <p>
        If we believe that you have fraudulently induced us to enter into the Agreement, and this has a material impact as defined in 11.1 above, or we cannot locate you after making reasonable attempts to do so, or we are otherwise authorised by a court or tribunal, then we are not required to give you a Default Notice and the Unpaid Balance will become due and payable within 3 business days written notice to you.
      </p>
      <p>
      Unless we agree otherwise, and provided we have not called for payment of all money due under this BNPL Contract in accordance with Clause 11.2(a), while you are in default you must still make payments in accordance with the Financial Table until the outstanding balance is paid in full. 
      </p>
      <p>
      You indemnify us from and against any reasonable expense, loss, loss of profit, damage or liability which we incur as a result of default incurring, except to the extent caused by our fraud, negligence or wilful misconduct or the fraud, negligence or wilful misconduct of our employees, officers, contractors, agents or receivers.  
      </p>
      <h3>Termination</h3>
      <p>
        Except to the extent provided elsewhere in this BNPL Contract, this BNPL Contract will continue until terminated by you or us in accordance with this clause 12.
      </p>
      <p>
        Either you or we may terminate this BNPL Contract immediately by notice provided that the Unpaid Balance is nil.
      </p>
      <p>
        If the Unpaid Balance is greater than nil, then:
      </p>
      <ul class="lower-alpha">
        <li>You may terminate this BNPL Contract only after paying out the Unpaid Balance in accordance with this BNPL Contract; and </li>
        <!-- What is the plan with the dead link? -->
        <li>we may only terminate this BNPL Contract in accordance with clauses 1.5 and 11.2(b) above.</li>
      </ul>
      <h3>General matters</h3>
      <p>You must pay us on request any</p>
      <ul class="lower-alpha">
        <li>government duties, taxes; and</li>
        <li>
          other charges on receipts, duties of withdrawals that apply to your loan. We may debit these duties, taxes and charges to your Loan Account as and when they become payable. 
        </li>
      </ul>
      <p>
        You must promptly produce documents (such as financial statements) or other evidence we require to enable us to verify your identity or other information about you.
      </p>
      <p>You must tell us if you change your residential, postal, email address or contact number.</p>
      <p>
      There may be some statutes (i.e., laws passed by parliament) or other law (usually called common law) intended to limit our rights. None of those statutes or laws will operate to limit our rights under this BNPL Contract unless by law those rights cannot be negated. In particular, we need not give any notice before exercising any right, power or remedy under this BNPL Contract unless required by law. If the law does require notice, we need only give one day’s notice, or the shortest notice required by that law.
      </p>
      <p>
        If the law does require us to give you notice before exercising rights, we may not have to give notice if:
      </p>
      <ol class="lower-alpha">
        <li>we cannot locate you after making reasonable attempts to do so; or</li>
        <li>we are authorised by a court.</li>
        </ol>
      <p>
        If any of the provisions of this BNPL Contract are illegal or become illegal at any time, the affected provisions will cease to have effect, but the balance of the BNPL Contract will remain in full force and effect.
      </p>
      <p>
        Statements of account will be forwarded to you at least once every six months or more frequently if requested by you or as required by law.
      </p>
      <p>
       Subject to your rights under this BNPL Contract, we may assign, novate, transfer, grant a security interest in, or otherwise deal with, our rights and obligations under or in connection with this BNPL Contract, without the need to give notice to you or obtain your consent. In the event that we assign, novate or transfer our rights or obligations under this BNPL Contract, you acknowledge, agree and consent to us providing your “personal information”, “credit eligibility information” and “credit information” (as those terms are defined in the Privacy Act 1988 (Cth) to the assignee. We represent that our rights under this clause and your obligation to make payments free of any set-off, deduction or counterclaim are requirements of this BNPL Contract, or are otherwise reasonably necessary to protect our legitimate business interests under this Agreement.
      </p>
      <p>
      You may not assign, transfer or otherwise deal with any of your rights or obligations under this Agreement without our prior written consent. 
      </p>
      <p>
      Any communications, originating process, court document or other document to be given or served under or in connection with this BNPL Contract or any security associated with this BNPL Contract may be:
      </p>
      <ol class="lower-alpha">
        <li>delivered personally to you;</li>
        <li>posted to or left at your residential or business address last known to us;</li>
        <li>posted to or left at the address shown in your BNPL Contract;</li>
        <li>sent by electronic communication (for example, email or SMS); or</li>
        <li>given in any other way permitted by law.</li>
      </ol>
      <p class="counter-skip">The notice may be signed by any employee, solicitor, or agent on our behalf.</p>
      <p>
        This BNPL Contract is governed by and interpreted in accordance with the law for the time being in force in the place shown as your address in this BNPL Contract. 
      </p>
      <p>
        The BNPL Code sets out standards of practice and service in the Australian Buy Now Pay Later industry. We comply with the BNPL Code where it applies to the services that we provide to you under this BNPL Contract.
      </p>
      <!-- is this meant to be before the definitions section? -->
      <p class="counter-skip">
        References to a person include a reference to companies and trusts and any other kind of body. Singular words include plural words and vice versa.
      </p>
      <h3>Definitions</h3>
      <p class="counter-skip">
        In this BNPL Contract, capitalised terms have the meaning given in the Payright Account Terms and Conditions or as otherwise specified below:
      </p>
      <ul class="none list-padding-below">
        <li>
          <span class="bold">Advance</span> means any part of the Credit Limit we advance to you.
        </li>
        <li>
          <span class="bold">Applicable Law</span> means Australian Consumer Law, the Credit Act, the BNPL Code and any other applicable laws, regulations and regulator guidance, codes of conduct that apply to this BNPL Contract from time to time.
        </li>
        <li>
          <span class="bold">Application</span> means your application for a BNPL Contract, an increase in your Credit Limit or any application for an Advance under a BNPL Contract.
        </li>
        <li>
          <span class="bold">Australian Consumer Law</span> means Schedule 2 of the Competition and Consumer Act 2010 (Cth), as updated from time to time.
        </li>
        <li>
          <span class="bold">Available Credit Limit</span>  means the amount of credit available at any point in time in connection with your BNPL Contract, being the Credit Limit less the Unpaid Balance.
        </li>
        <li>
          <span class="bold">BNPL Code</span> means the Australian Finance Industry Association Code of Practice for Buy Now Pay Later Providers, as updated from time to time.
        </li>
        <li>
          <span class="bold">BNPL Contract</span> means this contract between you and Payright, including the Financial Table.
        </li>
        <li>
          <span class="bold">BNPL Plan</span> means any Advance issued to you under your BNPL Contract in which you utilise the funds to complete your purchase from a Participating Payright Merchant. 
        </li>
        <li>
          <span class="bold">Credit Act</span> means the National Consumer Credit
          Protection Act 2009 (Cth) and accompanying Regulations.
        </li>
        <li>
          <span class="bold">Credit Limit</span> means the credit limit set out in the Financial Table attached to this BNPL Contract.
        </li>
        <li>
          <span class="bold">Default</span> has the meaning given in clause 11.
        </li>
        <li>
          <span class="bold">Default Notice</span> means the written notice provided to you by us notifying you that you are in default of this BNPL Plan Contract, setting out the particulars of the default and advising you on the means to rectify the default (if available).
        </li>
        <li>
          <span class="bold">Default Rate</span> means the default rate appearing in the Financial Table.
        </li>
        <li>
          <span class="bold">Fees and Charges</span> means the fees and charges set out in the Financial Table attached to this BNPL Contract (as varied by us in accordance with your Agreement). 
        </li>
        <li>
          <span class="bold">Fee Period</span> means both the Initial Fee Period and each Subsequent Fee Period.
        </li>
        <li>
          <span class="bold">Financial Table</span> means the table on page 1 of this BNPL Contract.
        </li>
        <li>
          <span class="bold">Initial Fee Period</span> means: 
          <ul class="list-padding-below">
            <li>If you were an existing customer of Payright at 10 June 2025, the period 10 June 2025 to 9 June 2026; or </li>
            <li>If you were not an existing customer at 10 June 2025, the 12 month period from the date of commencement of this BNPL Contract.</li>
          </ul>
        </li>
        <li>
          <span class="bold">Late Payment Fee</span> means any such fee detailed in the Financial Table.
        </li>
        <li>
          <span class="bold">Late Payment Notice</span> means a notice provided to you by Payright if you fail to make a payment under this BNPL Contract by the due date for that payment.
        </li>
        <li>
          <span class="bold">Late Account</span> means the records relating to the BNPL Contract as shown in your Payright Account.
        </li>
        <li>
          <span class="bold">Plan Date</span> means the date we first advance any part of the Credit Limit to you.
        </li>
        <li>
          <span class="bold">Payright Account</span> has the meaning given in the Payright Account Term and Conditions.
        </li>
        <li>
          <span class="bold">Repayment Amount</span> means the repayment amount applicable to a given Advance, as shown in the Repayments Schedule.
        </li>
        <li>
          <span class="bold">Payright Account Terms and Conditions</span> means the term and conditions governing your Payright Account.
        </li>
        <li>
          <span class="bold">Participating Payright Merchant</span> means an accredited merchant with whom Payright has a distribution agreement in place and whom Payright has authorised to distribute Payright BNPL Contracts to assist with the purchase by You of their goods and services. 
        </li>
        <li>
          <span class="bold">Subsequent Fee Period</span> means: 
           <ul class="list-padding-below">
            <li>If you were an existing customer of Payright at 10 June 2025, each 12 month period from 10 June in any given year until 9 June in the following year; or </li>
            <li>If you were not an existing customer at 10 June 2025, the 12 month period from each anniversary date of the commencement of this BNPL Contract. </li>
          </ul>
        </li>

        <li>
          <span class="bold">Unpaid Balance</span> on any given day means the amount you owe us at the close of that day, being the aggregation of all amounts debited and credited to your Loan Account.
        </li>
        <li>
          <span class="bold">You</span> or <span class="bold">your</span> means the borrower/s named in Item 1 of the Schedule. If there is more than one of you, each of you is liable jointly and each of you is liable severally. This will continue, as regards the others, even if one or more of you is no longer liable.
        </li>
        <li>
          <span class="bold">We, us or our</span> means Navalo Financial Services Group Pty Ltd acting as agent of Devizo Finance Pty Ltd.
        </li>
      </ul>
    </section>
    <br><div class="page"></div>
    <section>
      <p>
        The following statement is prescribed by law. Not all of the information in this statement may apply to you.
      </p>
      <h2 class="center">INFORMATION STATEMENT THINGS YOU SHOULD KNOW ABOUT YOUR PROPOSED CREDIT CONTRACT </h2>
      <p>
        This statement tells you about some of the rights and obligations of yourself and your credit provider. It does not state the terms and conditions of your contract.
      </p>
      <p>
        If you have any concerns about your contract, contact the credit provider and, if you still have concerns, the AFCA scheme, or get legal advice.
      </p>
      <table>
        <tbody>
          <tr class="bg-grey">
            <th class="center">THE CONTRACT</th>
          </tr>
          <tr>
            <td class="counter">
              <h3>How can I get details of my proposed credit contract?</h3>
              <p class="counter-skip">
                Your credit provider must give you a precontractual statement containing certain information about your contract. The precontractual statement, and this document, must be given to you before—
              </p>
              <ul>
                <li>your contract is entered into; or</li>
                <li>you make an offer to enter into the contract;
                whichever happens first.</li>
              </ul>
              <h3>How can I get a copy of the final contract?</h3>
              <p class="counter-skip">
                If the contract document is to be signed by you and returned to your credit provider, you must be given a copy to keep. Also, the credit provider must give you a copy of the final contract within 14 days after it is made. This rule does not, however, apply if the credit provider has previously given you a copy of the contract document to keep. If you want another copy of your contract, write to your credit provider and ask for one. Your credit provider may charge you a fee. Your credit provider has to give you a copy—
              </p>
              <ul>
                <li>within 14 days of your written request if the original contract came into existence 1 year or less before your request; or</li>
                <li>otherwise within 30 days of your written request.</li>
              </ul>
              <h3>Can I terminate the contract?</h3>
              Yes. You can terminate the contract by writing to the credit provider so long as —
              <ul>
                <li>you have not obtained any credit under the contract; or </li>
                <li>
                  a card or other means of obtaining credit given to you by your credit provider has not been used to acquire goods or services for which credit is to be provided under the contract.
                </li>
              </ul>
              <p class="counter-skip">
                However, you will still have to pay any fees or charges incurred before you terminated the contract.
              </p>
              <h3>Can I pay my credit contract out early?</h3>
              <p class="counter-skip">
                Yes. Pay your credit provider the amount required to pay out your credit contract on the day you wish to end your contract.
              </p>
              <h3>How can I find out the pay out figure?</h3>
              <p class="counter-skip">
                You can write to your credit provider at any time and ask for a statement of the pay out figure as at any date you specify. You can also ask for details of how the amount is made up.
              </p>
              <p class="counter-skip"> 
                Your credit provider must give you the statement within 7 days after you give your request to the credit provider. You may be charged a fee for the statement.
              </p>
              <h3>Will I pay less interest if I pay out my contract early?</h3>
              <p class="counter-skip">
                Yes. The interest you can be charged depends on the actual time money is owing. However, you may have to pay an early termination charge (if your contract permits your credit provider to charge one) and other fees.
              </p>
              <h3>Can my contract be changed by my credit provider?</h3>
              <p class="counter-skip">
                Yes, but only if your contract says so.
              </p>
              <h3>Will I be told in advance if my credit provider is going to make a change in the contract?</h3>
              <p class="counter-skip">
                That depends on the type of change. For example—
              </p>
              <ul>
                <li>
                  you get at least same day notice for a change to an annual percentage rate. That notice may be a written notice to you or a notice published in a newspaper.
                </li>
                <li>
                  you get 20 days advance written notice for—
                  <ul>
                    <li>a change in the way in which interest is calculated; or</li>
                    <li>a change in credit fees and charges; or</li>
                    <li>any other changes by your credit provider;</li>
                  </ul>
                </li>
              </ul>
              <p class="counter-skip">except where the change reduces what you have to pay or the change happens automatically under the contract.</p>
              <h3>Is there anything I can do if I think that my contract is unjust?</h3>
              <p class="counter-skip">
                Yes. You should first talk to your credit provider. Discuss the matter and see if you can come to some arrangement.
              </p>
              <p class="counter-skip">
                If that is not successful, you may contact the AFCA scheme. The AFCA scheme is a free service established to provide you with an independent mechanism to resolve specific complaints. The AFCA scheme can be contacted at <a href="tel:+611800931678" class="colour-black">1800 931 678</a>, <a target="_blank" class="break-word" href="https://www.afca.org.au/">https://www.afca.org.au/</a> and GPO Box 3, Melbourne, VIC 3001.
              </p>
              <p class="counter-skip">
                Alternatively, you can go to court. You may wish to get legal advice, for example from your community legal centre or Legal Aid.
              </p>
              <p class="counter-skip">You can also contact ASIC, the regulator, for information on <a href="tel:+611300300630" class="colour-black">1300 300 630</a> or through
              ASIC’s website at <a target="_blank" class="break-word" href="https://www.asic.gov.au.">https://www.asic.gov.au.</a></p>
            </td>
          </tr>
          <tr class="bg-grey">
            <th class="center">General</th>
          </tr>
          <tr>
            <td class="counter">
              <h3 style="counter-set: section 10;">What do I do if I can not make a repayment?</h3>
              <p class="counter-skip">
              Get in touch with your credit provider immediately. Discuss the matter and see if you can come to some arrangement. You can ask your credit provider to change your contract in a number of ways—
              </p>
              <ul>
                <li>to extend the term of your contract and reduce payments; or</li>
                <li>to extend the term of your contract and delay payments for a set time; or</li>
                <li>to delay payments for a set time.</li>
              </ul>
              <h3>What if my credit provider and I can not agree on a suitable arrangement?</h3>
              <p class="counter-skip">
                If the credit provider refuses your request to change the repayments, you can ask the credit provider to review this decision if you think it is wrong.
              </p>
              <p class="counter-skip">
                If the credit provider still refuses your request you can complain to the AFCA scheme. Further details about this scheme are set out below.
              </p>
              <h3>Can my credit provider take action against me?</h3>
              <p class="counter-skip">
                Yes, if you are in default under your contract. But the law says that you can not be unduly harassed or threatened for repayments. If you think you are being unduly harassed or threatened, contact the AFCA scheme or ASIC, or get legal advice.
              </p>
              <h3>Do I have any other rights and obligations?</h3>
              <p class="counter-skip">
                Yes. The law will give you other rights and obligations. You should also READ YOUR CONTRACT carefully.
              </p>
            </td>
          </tr>
          <tr>
            <td class="bg-grey bold">
              <p>
                IF YOU HAVE ANY COMPLAINTS ABOUT YOUR CREDIT CONTRACT, OR WANT MORE
                INFORMATION, CONTACT YOUR CREDIT PROVIDER. YOU MUST ATTEMPT TO RESOLVE
                YOUR COMPLAINT WITH YOUR CREDIT PROVIDER BEFORE CONTACTING THE AFCA
                SCHEME. IF YOU HAVE A COMPLAINT WHICH REMAINS UNRESOLVED AFTER
                SPEAKING TO YOUR CREDIT PROVIDER YOU CAN CONTACT THE AFCA SCHEME OR
                GET LEGAL ADVICE.
              </p>
              <p>
                THE AFCA SCHEME IS A FREE SERVICE ESTABLISHED TO PROVIDE YOU WITH AN
                INDEPENDENT MECHANISM TO RESOLVE SPECIFIC COMPLAINTS. THE AFCA SCHEME
                CAN BE CONTACTED AT <a href="tel:+611800931678">1800 931 678</a>, <a target="_blank" class="break-word" href="https://www.afca.org.au">HTTPS://WWW.AFCA.ORG.AU/</a> AND GPO BOX 3,
                MELBOURNE, VIC 3001.
              </p>
              <p>
                PLEASE KEEP THIS INFORMATION STATEMENT. YOU MAY WANT SOME INFORMATION FROM IT AT A LATER DATE
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <br><br><div class="page"></div>
      <div class="border border-spacing-2 p-2 mb-1">
        <h3 class="center">IMPORTANT</h3>
        <div class="grid grid-cols-2 md:grid-cols-1">
          <div class="md:pr-4 pr-0">
            <h4 class="margin-left-1_5rem">BEFORE YOU SIGN</h4>
            <ul class="star">
              <li class="md:pb-4 pb-20">
                READ THIS CONTRACT DOCUMENT so that you know exactly what contract you are entering into and what you will have to do under the contract.
              </li>
              <li class="md:pb-4 pb-20">
                You should also read the information statement: ‘THINGS YOU SHOULD KNOW ABOUT YOUR PROPOSED CREDIT CONTRACT’.
              </li>
              <li class="md:pb-4 pb-20">
                Fill in or cross out any blank spaces.
              </li>
              <li class="md:pb-4 pb-20">
                Get a copy of this contract document.
              </li>
              <li class="md:pb-4 pb-20">
                <span class="bold">Do not sign</span> this contract document if there is anything you do not understand.
              </li>
            </ul>
          </div>
          <div class="md:pr-4 pr-0">
            <h4 class="margin-left-1_5rem">THINGS YOU MUST KNOW</h4>
            <ul class="star">
              <li class="md:pb-4 pb-20">
                Once you sign this contract document, you will be bound by it. However, you may end the contract before you obtain credit, or a card or other means is used to obtain goods or services for which credit is to be provided under the contract, by telling the credit provider in writing, but you will still be liable for any fees or charges already incurred.
              </li>
              <li class="md:pb-4 pb-20">
                If you take out insurance, the credit provider can not insist on any particular insurance company.
              </li>
              <li  class="md:pb-4 pb-20">
                If this contract document says so, the credit provider can vary the annual percentage rate (the interest rate), the repayments and the fees and charges and can add new fees and charges without your consent.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </body>
</html>`;
const planCurrencyTransformer = (currencyFormatter, plan) => {
  return {
    ...plan,
    establishmentFee: currencyFormatter.format(plan.establishmentFee),
    accountKeepingFee: currencyFormatter.format(plan.accountKeepingFee),
    loanAmount: currencyFormatter.format(plan.loanAmount),
    totalCreditAmount: currencyFormatter.format(plan.totalCreditAmount),
    repaymentAmount: currencyFormatter.format(plan.repaymentAmount),
    paymentProcessingFee: currencyFormatter.format(plan.paymentProcessingFee)
  };
};
const constructAddress = (address) => {
  const { street, suburb, state, postcode } = address;
  return `${street}, ${suburb}, ${state} ${postcode}`;
};
const bnplContractTemplate = ({
  address,
  currentDate,
  customer,
  includeResizerScript = true,
  plan,
  store
}) => {
  const currencyFormatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2
  });
  const bnplContractTemplate2 = handlebars.compile(rawBNPLContract.toString());
  const resizerScript = includeResizerScript ? `
      <script
         type="text/javascript"
      >${contentWindow}<\/script>
   ` : "";
  const totalPeriodicFees = (plan.accountKeepingFee + plan.paymentProcessingFee) * plan.terms;
  const totalFee = plan.establishmentFee + totalPeriodicFees;
  return bnplContractTemplate2({
    address: constructAddress(address),
    currentDate: currentDate.toLocaleDateString("en-AU", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }),
    customer,
    isMonthly: plan.repaymentFrequency === "Monthly",
    isFortnightly: plan.repaymentFrequency === "Fortnightly",
    periodicFee: currencyFormatter.format(totalFee / plan.terms),
    plan: planCurrencyTransformer(currencyFormatter, plan),
    resizerScript,
    sumOfRepaymentsAndFees: currencyFormatter.format(50),
    store,
    totalFee: currencyFormatter.format(totalFee),
    totalFeeAndCharges: currencyFormatter.format(1e3)
  });
};
export {
  bnplContractTemplate as b,
  contentWindow as c
};
